"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Pizzicato = require("pizzicato");
function playAlarm(volume) {
    if (volume === void 0) { volume = 1; }
    var sound = new Pizzicato.Sound({ source: "wave", options: { release: 3, volume: volume } });
    sound.play();
    setTimeout(function () { return sound.stop(); }, 500);
}
exports.playAlarm = playAlarm;



//////////////////
// WEBPACK FOOTER
// ./src/infra/audio.ts
// module id = 672
// module chunks = 0